export default __webpack_public_path__ + "static/advance-94a57e4a3500b0787825f82ee1978732.png";